export default __webpack_public_path__ + "assets/images/8b8ff479bb825db33d42fb9676422c22.svg";